import { useNavigate, useSearchParams } from 'react-router-dom';

export default function CtaSection() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const handleStart = () => {
    const params = searchParams.toString();
    navigate(params ? `/survey?${params}` : '/survey');
  };

  return (
    <div
      className="flex flex-col items-center w-full"
      style={{ animationDelay: '600ms' }}
    >
      <button
        onClick={handleStart}
        className="w-full h-[52px] bg-[#C6503C] hover:bg-[#A63C2C] active:scale-[0.97] 
                   text-white text-base font-semibold rounded-xl transition-all duration-200
                   shadow-lg shadow-[#C6503C]/15 flex items-center justify-center gap-2
                   cursor-pointer whitespace-nowrap"
      >
        설문 시작하기
        <i className="ri-arrow-right-line text-lg" />
      </button>
      <a
        href="#privacy"
        className="text-xs text-[#55575D] mt-3 underline underline-offset-2 hover:text-[#C6503C] transition-colors cursor-pointer"
      >
        개인정보 처리방침
      </a>
    </div>
  );
}